import LoginPage from './Login'

const Login = () => (
    <LoginPage/>
)

export default Login
